"use server";

import { redirect } from "next/navigation";
import { createSession } from "@/lib/auth";
import { sql } from "@/lib/db";
import { verifyPassword } from "@/lib/password";

export type LoginState = { error?: string } | undefined;

export async function login(
  _state: LoginState,
  formData: FormData,
): Promise<LoginState> {
  const email = formData.get("email");
  const password = formData.get("password");

  if (typeof email !== "string" || typeof password !== "string") {
    return { error: "Identifiants invalides." };
  }

  const [user] = await sql<
    { id: string; passwordHash: string; isActive: boolean }[]
  >`
    SELECT
      id,
      password_hash AS "passwordHash",
      is_active AS "isActive"
    FROM users
    WHERE lower(email) = lower(${email.trim()})
    LIMIT 1
  `;

  if (
    !user?.isActive ||
    !(await verifyPassword(password, user.passwordHash))
  ) {
    return { error: "Adresse e-mail ou mot de passe incorrect." };
  }

  await createSession(user.id);
  redirect("/");
}
